import { motion } from 'framer-motion'
import { Button } from '../ui/Button'

export function CtaSection() {
  return (
    <section
      style={{
        padding: '120px 0',
        background: 'var(--bg-2)',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          maxWidth: 700,
          margin: '0 auto',
          padding: '0 48px',
        }}
      >
        <motion.span
          initial={false}
          animate={{ opacity: 1 }}
          style={{
            fontSize: 12,
            fontWeight: 600,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: 'var(--white-dim)',
            marginBottom: 24,
            display: 'block',
          }}
        >
          Get Started
        </motion.span>
        <motion.h2
          initial={false}
          animate={{ opacity: 1 }}
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            fontWeight: 900,
            fontSize: 'clamp(46px, 6.5vw, 76px)',
            textTransform: 'uppercase',
            lineHeight: 1.0,
            marginBottom: 24,
            color: 'var(--white)',
          }}
        >
          Stop managing tech. <span style={{ color: 'var(--accent)' }}>Start growing.</span>
        </motion.h2>
        <motion.p
          initial={false}
          animate={{ opacity: 1 }}
          style={{
            fontSize: 16,
            color: 'var(--white-dim)',
            lineHeight: 1.65,
            marginBottom: 48,
          }}
        >
          30-minute call. No pressure. You'll leave with a clear picture of what managed IT + AI automation could do for your business — and exactly what it would cost.
        </motion.p>
        <motion.div
          initial={false}
          animate={{ opacity: 1 }}
          className="flex gap-4 justify-center flex-wrap"
        >
          <Button to="/contact" variant="primary">
            Book Your Free Discovery Call
          </Button>
          <a
            href="/#calculator"
            className="btn-ghost inline-flex items-center justify-center no-underline"
            style={{ textDecoration: 'none' }}
          >
            Calculate Your ROI First
          </a>
        </motion.div>
      </div>
    </section>
  )
}
